import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Badge, Popover, OverlayTrigger } from 'react-bootstrap';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
};

// Custom toggle component for the dropdown to use an icon
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="text-dark p-2"
    >
      {children}
    </a>
  ));

const SortableEventPlanItem = ({ item, formatDuration, handleOpenEditItemModal, handleDeleteItemClick, canEditEvent }) => {
    const isMobile = useIsMobile();
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const songPopover = item.song && (
        <Popover id={`popover-song-${item.id}`}>
            <Popover.Header as="h3">
                {item.arrangement ? (
                    <Link to={`/songs/${item.song.id}#arrangement-${item.arrangement.id}`}>Детали песни</Link>
                ) : (
                    "Детали песни"
                )}
            </Popover.Header>
            <Popover.Body>
                {item.arrangement ? (
                    <div>
                        <div><strong>Тональность:</strong> {item.arrangement.key || '-'}</div>
                        <div><strong>Темп:</strong> {item.arrangement.bpm ? `${item.arrangement.bpm} BPM` : '-'}</div>
                        <div><strong>Размер:</strong> {item.arrangement.time_signature || '-'}</div>
                    </div>
                ) : (
                    <div className="text-muted">Аранжировка не выбрана</div>
                )}
            </Popover.Body>
        </Popover>
    );

    const descriptionContent = (
        <>
            {item.song ? (
                <>
                    <OverlayTrigger
                        trigger="click"
                        rootClose={true}
                        placement="auto"
                        overlay={songPopover}
                    >
                        <span style={{ cursor: 'pointer' }} className="text-primary">{item.song.title}</span>
                    </OverlayTrigger>
                    {item.arrangement && item.arrangement.key && (
                        <Badge bg="secondary" className="ms-2">{item.arrangement.key}</Badge>
                    )}
                </>
            ) : (
                item.name || 'Без названия'
            )}
            {item.description && <div className="text-muted small">{item.description}</div>}
        </>
    );

    if (item.is_group_header) {
        return (
            <tr ref={setNodeRef} style={style} className="table-secondary">
                {canEditEvent && (
                    <td {...attributes} {...listeners} style={{ cursor: 'grab' }}>
                        <i className="fas fa-grip-vertical"></i>
                    </td>
                )}
                <td colSpan={canEditEvent ? "4" : "4"} className="fw-bold text-uppercase">
                    {item.name}
                </td>
                {canEditEvent && (
                     <td className="text-end">
                        <Dropdown>
                            <Dropdown.Toggle as={CustomToggle} id={`dropdown-actions-${item.id}`}>
                                <i className="fas fa-ellipsis-v"></i>
                            </Dropdown.Toggle>
                    
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleOpenEditItemModal(item)}>Изменить</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDeleteItemClick(item.id)} className="text-danger">Удалить</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </td>
                )}
            </tr>
        );
    }

    return (
        <tr ref={setNodeRef} style={style}>
            {canEditEvent && (
                <td {...attributes} {...listeners} style={{ cursor: 'grab' }}>
                    <i className="fas fa-grip-vertical"></i>
                </td>
            )}

            {isMobile ? (
                <td colSpan="4">
                    {descriptionContent}
                </td>
            ) : (
                <>
                    <td>{formatDuration(item.duration)}</td>
                    <td>{descriptionContent}</td>
                    <td>{item.comment || '-'}</td>
                    <td>{item.responsible || '-'}</td>
                </>
            )}

            {canEditEvent && (
                 <td className="text-end">
                    <Dropdown>
                        <Dropdown.Toggle as={CustomToggle} id={`dropdown-actions-${item.id}`}>
                            <i className="fas fa-ellipsis-v"></i>
                        </Dropdown.Toggle>
                
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleOpenEditItemModal(item)}>Изменить</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDeleteItemClick(item.id)} className="text-danger">Удалить</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </td>
            )}
        </tr>
    );
};

export default SortableEventPlanItem;